module.exports = __webpack_public_path__ + "static/img/3.4832a05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/3.png
// module id = 8JL4
// module chunks = 0